import { useState, useEffect } from "react";


const useLocalStorage = (key, defaultValue) => {
    const [storedValue, setStoredValue] = useState(defaultValue)

    useEffect(() => {
        const storedItem = window.localStorage.getItem(key)
        storedItem !== null ? setStoredValue(JSON.parse(storedItem)) : setStoredValue(defaultValue)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        window.localStorage.setItem(key, JSON.stringify(storedValue))
    }, [storedValue]) // eslint-disable-line react-hooks/exhaustive-deps

    return [storedValue, setStoredValue]
}

export default useLocalStorage